import React, {useEffect} from 'react';
import styles from "./SelectScenario.module.scss"
import ContentBox from "../../common/ContentBox/ContentBox";
import QuestionGroup from "../../QuizV2/QuestionGroup/QuestionGroup";
import Option from "../../QuizV2/QuestionGroup/Option/Option";
import DogEar from "../../../../partials/DogEar/DogEar";
import Button from "../../../../partials/Button";

function SelectScenario({doSkip = false, story, onSelected, onComplete, doCompleteSegment = false, completeButtonCaption = 'COMPLETE SEGMENT'}) {
    const [stories,setStories] = React.useState( () => {
        return story.map(s => ({
            ...s,
            selected: false
        }))
    })
    const [selectedScenario, setSelectedScenario ] = React.useState()

    const handleScenarioClick  = (selected) => {
        setSelectedScenario(selected)
        setStories(stories.map( s => {
                    return {
                            ...s,
                            selected: selected.name === s.name
                    }
        }))
    }
    const handleScenarioSelectButtonClick = () => {
        if (selectedScenario) {
            onSelected(selectedScenario)
        }
    }
    return <div className={styles.SelectScenario}>

        {doSkip === false && <><ContentBox title={story[0]?.header}  fitContent={true}>
        {story[0]?.body || 'Invalid Story 0 body'}
            </ContentBox>
            <QuestionGroup>
                {stories &&
                stories.map( (q,i) => {
                    if (i === 0) {
                        return null;
                    }
                    return <Option
                        selected={q.selected} key={q.text} option={q} onSelected={ handleScenarioClick }>{q.name}</Option>
                })}
            </QuestionGroup>
            <div className={styles.SelectButton}>
            <Button className={styles.ActionButton}
                    onClick={handleScenarioSelectButtonClick}
                    text={'SELECT'}
            >
            </Button>
            </div></>}
                {doSkip === true && doCompleteSegment === true && <div className={styles.CompleteButton}>
                    <Button
                         onClick={() => {
                             if (onComplete) {
                                 onComplete();
                             }
                         }}
                         text={completeButtonCaption }

                    /></div>}

        </div>
}
export default SelectScenario;
